import { useQueryParam, ArrayQueryOptions } from 'labguard-cdk'

export default function useStatusFilter() {
  return useQueryParam('status', ArrayQueryOptions)
}
